import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const ProtectedRoute = ({
  component: Component, accessFunc, ...rest
}) => {
  const {
    hasAccess,
    redirectPath,
  } = accessFunc();

  return (
    <Route
      {...rest}
      render={(props) => (
        hasAccess
          ? <Component {...props} />
          : <Redirect to={redirectPath} />
      )}
    />
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  accessFunc: PropTypes.func.isRequired,
};

export default ProtectedRoute;
